import { configureStore } from "@reduxjs/toolkit";
//Store Reducers
import authReducer from "./slices/authSlice";
import companyReducer from "./slices/companySlice";
import commonReducer from "./slices/commonSlice";
import referralReducer from "./slices/referralSlice";
const store = configureStore({
  reducer: { authReducer, companyReducer, commonReducer, referralReducer },
});

export default store;
